import useCalendar from "../../context/useCalendar";
import { addMinutes } from "../utils";
import { setHours, setMinutes } from "date-fns";

const useGetTimes = (dayStart: Date) => {
    const {
        calendarSettings: { calendarEnd, calendarStart, intervalLength },
    } = useCalendar();

    let current = setMinutes(setHours(dayStart, calendarStart), 0);
    const times: Date[] = [];
    while (current.getHours() < calendarEnd) {
        times.push(current);
        current = addMinutes(current, intervalLength);
    }
    times.push(current);

    return times;
};

export default useGetTimes;
